import { useCallback } from 'react';

import { useRootLoaderData } from '@jane/bloom/hooks/useRootLoaderData';
import { deriveBasename } from '@jane/bloom/utils/deriveBasename';

/**
 * Provides a function that turns a basename-relative path into an href the
 * browser can navigate to directly.
 *
 * This is the single place where the basename is re-attached for navigations
 * that bypass React Router (`window.location`, `window.open`, plain anchors).
 * Unlike `<Link>`, `redirect()` and `navigate()` — which the router prefixes
 * with its configured basename — these go straight to the browser, so the
 * basename must already be present in the URL.
 */
export const useBrowserHref = () => {
  const { menuUrl } = useRootLoaderData();

  return useCallback(
    (relativePath: string) => `${deriveBasename(menuUrl)}${relativePath}`,
    [menuUrl]
  );
};
